import { render, staticRenderFns } from "./voucher-sale-confirmation.vue?vue&type=template&id=c283f29a&scoped=true&"
import script from "./voucher-sale-confirmation.vue?vue&type=script&lang=js&"
export * from "./voucher-sale-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./voucher-sale-confirmation.vue?vue&type=style&index=0&id=c283f29a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c283f29a",
  null
  
)

export default component.exports